import { AnimatePresence } from "framer-motion";
import React, { useState, useCallback } from "react";

import { getModuleThemeColors } from "@brexhq/next/src/components/pageBuilder/ModuleLayout";
import { buildBynderImageUrl } from "@brexhq/next/src/components/shared/BynderAsset/Image/LegacyImage";
import { PartnerState } from "@brexhq/next/src/contexts/Site";
import useSiteContext from "@brexhq/next/src/hooks/useSiteContext";
import { Icon } from "@brexhq/shared/components/deprecated/Icons";

import {
  CloseIcon,
  MotionDiv,
  PartnerBarWrapper,
  PartnerBannerContent,
  PartnerLogoImage,
  ReadMoreButton,
} from "./PartnerBanner.elements";

export const PartnerBanner: React.FC<PartnerState> = ({ response }) => {
  const [isOpen, setOpen] = useState(true);
  const [showPartnerBanner, setShowPartnerBanner] = useState(true);
  const theme = "PrimaryGray";
  const {
    standard: { icons },
  } = getModuleThemeColors(theme);

  const {
    partnerBanner: { updatePartnerBanner },
  } = useSiteContext();

  const handleReadMoreClick = useCallback(() => {
    setOpen(!isOpen);
  }, [isOpen]);

  const handleClose = useCallback(() => {
    setShowPartnerBanner(false);
    setTimeout(() => {
      updatePartnerBanner({
        isVisible: false,
      });
    }, 500);
  }, [updatePartnerBanner]);

  if (response) {
    return (
      <>
        {showPartnerBanner && (
          <PartnerBarWrapper>
            <PartnerBannerContent>
              {/* Logo */}
              {response?.partnerLogo && (
                <div>
                  <PartnerLogoImage
                    src={buildBynderImageUrl(response.partnerLogo.image, {
                      width: 200,
                    })}
                    alt={`${response.title} logo`}
                  />
                </div>
              )}
              {/* Description */}
              <div>{response.introDescription}</div>
              <AnimatePresence initial={false}>
                {isOpen && (
                  <MotionDiv name="descriptionContainer">
                    {response.description}
                  </MotionDiv>
                )}
              </AnimatePresence>

              {!isOpen && (
                <ReadMoreButton onClick={handleReadMoreClick}>
                  Read More
                </ReadMoreButton>
              )}
            </PartnerBannerContent>

            {/* Shrink/Expand Icon */}
            <CloseIcon onClick={handleClose}>
              <Icon width={16} height={16} icon="CloseBanner" color={icons} />
            </CloseIcon>
          </PartnerBarWrapper>
        )}
      </>
    );
  } else {
    return null;
  }
};
